import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "school",
    title: "Classrooms & Common Areas",
    description:
      "We clean and sanitise classrooms, corridors, canteens, and common areas to a consistent standard throughout the academic term.",
  },
  {
    icon: "sports_gymnastics",
    title: "Sports Halls & Changing Rooms",
    description:
      "We maintain sports halls, changing rooms, and shower facilities to a high standard of hygiene — reducing the spread of bacteria and odours.",
  },
  {
    icon: "schedule",
    title: "Term-Time & Holiday Scheduling",
    description:
      "We offer flexible cleaning schedules to suit term-time routines and more intensive deep cleans during school holidays.",
  },
  {
    icon: "verified_user",
    title: "Vetted & Garda-Checked Staff",
    description:
      "All staff working in educational settings are fully vetted and Garda-checked, ensuring the safety of pupils and staff at all times.",
  },
];

function School_Section1() {
  return (
    <ServiceHighlights
      title="Why Choose Our School & Educational Facility Cleaning?"
      description="We provide reliable cleaning services for schools, colleges, and educational facilities — maintaining safe, hygienic environments that support learning and comply with health and safety standards."
      items={items}
    />
  );
}

export default School_Section1;
